export default __webpack_public_path__ + "static/media/pro-elevate-bpn-banner-3.e6930f02.jpg";